import React from 'react';

import './index.scss';

const SpTitle = ({ step, subStep, title, subTitle }) => (
  <div className="SpTitle">
    {step && step !== '0' && step !== '6' && (
      <div className="step">
        Step&nbsp;
        {step}
      </div>
    )}
    {subStep && (
      <div className="subStep">
        {subStep}
        /2問目
      </div>
    )}
    <div className="title">{title}</div>
    <div className="subTitle">{subTitle}</div>
    <div className="horizon" />
  </div>
);

export default SpTitle;
